import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { Text } from '@solvhealth/jigsaw-v1';
import styled from 'styled-components';
import useGetCalendarTime from '../../../../../../../hooks/useGetCalendarTime';
import { ActiveBookingStates } from '~/components/AccountGetsMarried/components/GetCare/components/AccountHeadline/components/AppointmentCard/util';

const Root = styled(Text).withConfig({ componentId: 'sc-18al65-0' })`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type Props = {
  appointment: any;
  bookingState: ActiveBookingStates;
};

const aptTimeCopy = (
  appointmentTime: any,
  bookingState: ActiveBookingStates,
  t: TFunction<'account'[]>
) => {
  switch (bookingState) {
    case ActiveBookingStates.PostTelemedNoRating:
    case ActiveBookingStates.PostClinicVisitNoRating:
    case ActiveBookingStates.PostTelemedHasRating:
    case ActiveBookingStates.PostClinicVisitHasRating:
    case ActiveBookingStates.PostVisitHasLabResult:
    case ActiveBookingStates.PostTelemedSummaryMissing:
    case ActiveBookingStates.PostTelemedSummaryPending:
    case ActiveBookingStates.PostTelemedSummaryDownloadable:
    case ActiveBookingStates.PostTelemedSummaryUpdatable:
    case ActiveBookingStates.PostTelemedSummaryViewable:
      return t('account:appointmentCard.aptTimeCopy.postVisit');
    default:
      return appointmentTime;
  }
};

const AppointmentTime = (props: Props) => {
  const { appointment, bookingState } = props;
  const { t } = useTranslation(['account']);

  const appointmentTime = useGetCalendarTime(appointment);

  return <Root variant="body">{aptTimeCopy(appointmentTime, bookingState, t)}</Root>;
};

export default AppointmentTime;
